import React from 'react';
import { Form, Select } from 'antd';

import { tags } from '../../../../../consts/tags';

const Tags = () => {
    return (
        <Form.Item label="Tagi" name="tags">
            <Select
                allowClear
                style={{ width: '100%' }}
                placeholder="Wybierz tagi opisujące trasę"
                optionFilterProp="label"
                mode="tags"
                // mode="multiple"
                options={tags.map((opt) => ({ label: opt, value: opt }))}
            />
        </Form.Item>
    );
};
export default Tags;
